import React = require('react');

import { beaconComponentRegistryEntry, getUserAccountSettingsURL } from '~src/beacon/BeaconComponentRegistryFunctions';
import { DeepLink } from '~src/beacon/deepLink/DeepLink';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { UserNotificationsUserSettings } from '~src/userNotifications/components/settings/UserNotificationsUserSettings';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { DataAlertNotification } from './SuspendedDataAlertSetting';
import { SubscriptionNotification } from './SuspendedSubscriptionSetting';

const DEEPLINK_ID = 'user-notification-preferences';

export type NotificationsSettingsProps = {
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  userHasNoSiteId: boolean;
  isViewerAdmin: boolean;
  isUserNotificationsPlatformEnabled?: boolean;
}

export function NotificationsSettings(props: NotificationsSettingsProps): JSX.Element {
  return (
    <>
      <h3 className={UserSettingsStyle.titleText}>{Messages.userNotificationSettingsLabel()}</h3>
      <div>
          {props.isUserNotificationsPlatformEnabled &&
            <div>
                <DeepLink deepLinkId={DEEPLINK_ID}>
                    <div className={UserSettingsStyle.tbody}>
                      <div data-tb-test-id="userSettings-user-notifications-platform">
                        <UserNotificationsUserSettings />
                      </div>
                    </div>
                </DeepLink>
            </div>}
          {props.isViewerAdmin &&
            <>
              {props.isUserNotificationsPlatformEnabled && UserSettingsHelper.getSectionDividerLine()}
              <div>
                <div className={UserSettingsStyle.tbody} >
                  <SubscriptionNotification {...props} />
                </div>
              </div>
              {UserSettingsHelper.getSectionDividerLine()}
              <div>
                <div className={UserSettingsStyle.tbody} >
                  <DataAlertNotification {...props} />
                </div>
              </div>
            </>
          }
      </div>
    </>
  );
}

export const NotificationPreferencesSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.userNotificationSettingsLabel(),
  deeplinkId: DEEPLINK_ID,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  tags:  () => { return [Messages.userSettings_Preference_Header(), Messages.email(), Messages.slack(), Messages.teams()]; },
  isAdmin: false,
  isVisible: () => getSessionManagementServiceInstance().isUserNotificationsPlatformEnabled()
});